function dataTab({ t }: { t: (val: string) => string }) {
  const listTab = [
    {
      name: t('general.core'),
    },
    {
      name: t('general.leadership'),
    },
    {
      name: t('general.tech'),
    },
    {
      name: t('general.func'),
    },
  ];
  return { listTab };
}

export default dataTab;
